import c from 'classnames';
import styles from './Typography.module.css';

export type TypographyComponentVariant =
  | 'label' // 0.8125rem or 1rem (desktop w/ responsive prop)
  | 'body-xs' // 0.8125rem (13px)
  | 'body-s' // 1rem or 0.8125rem (mobile w/ responsive prop)
  | 'body-m' // 1.25rem
  | 'subHeadline' // 0.9375rem
  | 'heading-s' // 1rem
  | 'heading-m' // 1.125rem
  | 'heading-l' // 1.5rem or 1.25rem (mobile)
  | 'heading-xl' // 1.75rem or 1.5rem (mobile)
  | 'heading-2xl' // 2.125rem or 1.75rem (mobile)
  | 'heading-3xl'; // 2.5rem or 2rem (mobile)

const variantMap: {
  [key in TypographyComponentVariant]: TextVariantClass;
} = {
  label: 'label',
  'body-xs': 'bodyXS',
  'body-s': 'bodyS',
  'body-m': 'bodyM',
  subHeadline: 'subHeadline',
  'heading-s': 'headingS',
  'heading-m': 'headingM',
  'heading-l': 'headingL',
  'heading-xl': 'headingXL',
  'heading-2xl': 'heading2XL',
  'heading-3xl': 'heading3XL',
};
type TextVariantClass =
  | 'label'
  | 'bodyXS'
  | 'bodyS'
  | 'bodyM'
  | 'subHeadline'
  | 'headingS'
  | 'headingM'
  | 'headingL'
  | 'headingXL'
  | 'heading2XL'
  | 'heading3XL';
export enum TextColor {
  GREEN = 'green',
  DARKGREEN = 'darkGreen',
  PURPLE = 'purple',
  DARKPURPLE = 'darkPurple',
  BLUE = 'blue',
  DARKBLUE = 'darkBlue',
  DARK = 'dark',
  LIGHT_GREY = 'lightGrey',
  LIGHTER_GREY = 'lighterGrey',
  RED = 'red',
  DARKRED = 'darkRed',
  ORANGE = 'orange',
  DARKORANGE = 'darkOrange',
  GREY = 'grey',
  WHITE = 'white',
}
export type TextColorType =
  | 'green'
  | 'darkGreen'
  | 'purple'
  | 'darkPurple'
  | 'blue'
  | 'darkBlue'
  | 'dark'
  | 'lightGrey'
  | 'lighterGrey'
  | 'red'
  | 'darkRed'
  | 'orange'
  | 'darkOrange'
  | 'grey'
  | 'white';
export type TextWeight = 'bold' | 'heavy' | 'medium' | 'light';
export const getTextColorFromEvaluationColor = (color: string) => {
  switch (color) {
    case 'green':
      return TextColor.GREEN;
    case 'orange':
      return TextColor.ORANGE;
    case 'red':
      return TextColor.RED;
    case 'grey':
      return TextColor.GREY;
  }
  return TextColor.DARK;
};
export interface TypographyProps extends React.ComponentPropsWithoutRef<'span'> {
  variant: TypographyComponentVariant;
  medium?: boolean;
  light?: boolean;
  color?: TextColorType;
  responsive?: boolean;
  serif?: boolean;
  italic?: boolean;
  className?: string;
  weight?: TextWeight;
  children: React.ReactNode;
}
export const Typography = ({
  variant,
  medium,
  light,
  color,
  responsive,
  serif,
  italic,
  className,
  weight,
  children,
  ...props
}: TypographyProps) => {
  return (
    <>
      <span
        className={c(
          className,
          styles.typography,
          styles[variantMap[variant]],
          serif && styles.serif,
          italic && styles.italic,
          color && styles[color],
          weight && styles[weight],
          medium && styles.medium,
          light && styles.light,
          responsive && styles.responsive,
        )}
        {...props}
      >
        {children}
      </span>
    </>
  );
};

export default Typography;
